var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hide-on-mobile terminal-logo"},[_c('div',{staticClass:"logo"},[_c('input',{ref:"input",staticClass:"input",class:_vm.classes,attrs:{"autocomplete":"false","spellcheck":"false"},domProps:{"value":_vm.input},on:{"input":function($event){return _vm.updateInput($event.target.value)},"keyup":_vm.keyup}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }